import { InspectorRow, State } from "./InspectorRow";
import { InspectorGroup } from "./InspectorGroup";
import { useCurrencySymbol } from "src/hooks/useCurrencySymbol";
import { useTranslation } from "src/translations";

export const CostGroupLoading = () => {
  const currency = useCurrencySymbol();
  const { t } = useTranslation();
  return (
    <InspectorGroup label={t("costMetrics.title")}>
      <InspectorRow
        currency={currency}
        state={State.LOADING}
        label={t("costMetrics.modules")}
        value={0}
        decimalPoint={0}
      />
      <InspectorRow
        currency={currency}
        state={State.LOADING}
        label={t("costMetrics.fitOut")}
        value={0}
        decimalPoint={0}
      />
      <InspectorRow
        currency={currency}
        state={State.LOADING}
        label={t("costMetrics.baseBuild")}
        value={0}
        decimalPoint={0}
      />
      <InspectorRow
        currency={currency}
        state={State.LOADING}
        label={t("costMetrics.construction")}
        value={0}
        decimalPoint={0}
      />
      <InspectorRow
        currency={currency}
        state={State.LOADING}
        label={t("costMetrics.constructionPerUnit")}
        value={0}
        decimalPoint={0}
        unit={t("costMetrics.perUnit")}
      />
      <InspectorRow
        currency={currency}
        state={State.LOADING}
        label={t("costMetrics.constructionPerArea")}
        value={0}
        decimalPoint={0}
        unit={t("costMetrics.perSqm")}
      />
    </InspectorGroup>
  );
};
